import React, { Component } from "react";
import { Row, Col  } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as checkStatus from '../redux/list/status'; 
import { flashMessage } from '../redux/flash/actions';
import * as selectors from '../redux/selectors';
import * as actions from '../redux/list/actions';
import { getICGender, getICBirthdate } from '../utils/format';
import { sortByDateLatest } from '../utils/sort';
import { loopFunc } from '../utils/time';

import Logo from '../components/Logo';
import Table from '../components/Table';
import Date from '../components/Date';
import Identity from '../components/Identity';

import './ChecksPrint.css';

class ChecksPrint extends Component {
  static propTypes = {
    checks: PropTypes.array,
    loading: PropTypes.bool,
  }

  static defaultProps = {
    loading: false,
  }

  static mapStateToProps = state => ({
    checks: selectors.getListCheck(state),
    loading: selectors.getListCheckLoading(state),
  })

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    let { checks } = props;
    if (checks && checks.length > 0) {
      checks = checks.sort(sortByDateLatest);
    }
    this.state = {
      checks: props.checks,
      items: [],
    };
  }

  async componentDidMount() {
    await loopFunc(this.getList);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checks !== this.props.checks) {
      let { checks } = nextProps;
      if (checks && checks.length > 0) {
        checks = checks.sort(sortByDateLatest);
      }
      this.setState({ checks });
    }
  }

  getList = async (month) => {
    const { store } = this.context;
    const body = {
      month,
      status: 'request_success',
    };
    const res = await store.dispatch(actions.getListCheck(body));
    if (res === checkStatus.LIST_STATUS_OK) {
      const items = this.state.items.concat(this.props.checks);
      const checks = items;
      await this.setState({ checks });
    return;
    }
    store.dispatch(flashMessage('Error getting the list. Please refresh to try again.', 'error'));
  }

  handlePrint = (e) => {
    e.preventDefault();
    window.print();
  }

  filterSuccess = () => {
    const items = this.props.checks;
    const successData = items.filter(obj => {
      return obj.status === 'request_success';
    }).map((obj, i) =>
      <Row className="row-eq-height" key={i}>
        <Col xs={1}><Date>{obj.createdAt}</Date></Col>
        <Col xs={2}>
          {obj.name} <br/>
          <Identity type={1} identity={`${obj.nric}`} /> <br/>
          {getICGender(`${obj.nric}`)} <br />
          {getICBirthdate(`${obj.nric}`)} <br />
        </Col>
        <Col xs={2}>{obj.mobile} <br/> {obj.email}</Col>
        <Col xs={3}>
          Income: RM {obj.incomeNetCents/100} <br/>
          DSR: {obj.dsrPercent} % <br/>
          <br/>
          <b>Eligible Loan Amount</b> <br />
          Minimal Loan:{
            obj.loanCentsEligibleRange && obj.loanCentsEligibleRange[0].minLoanAmount !== 0 ?
            `RM ${obj.loanCentsEligibleRange[0].minLoanAmount/100}`
            : 'Not Eligible'
          }
          <br />
          Maximum Loan:{
            obj.loanCentsEligibleRange && obj.loanCentsEligibleRange[0].maxLoanAmount !== 0 ?
            `RM ${obj.loanCentsEligibleRange[0].maxLoanAmount/100}`
            : 'Not Eligible'
          }

        </Col>
        <Col xs={4}>
          <Row className="row-eq-height">
            <Col xs={4}><b>Car Loan</b></Col>
            <Col xs={8}>
              Amount: RM {obj.ccris ? obj.ccris.carLoanAmount : 'N/A'} <br/>
            Count: RM {obj.ccris ? obj.ccris.carLoanCount : 'N/A'} <br/>
            </Col>
          </Row>
          <Row className="row-eq-height">
            <Col xs={4}><b>Credit Card</b></Col>
            <Col xs={8}>
              Amount: RM {obj.ccris ? obj.ccris.creditCardLoanAmount : 'N/A'} <br/>
            Count: RM {obj.ccris ? obj.ccris.creditCardLoanCount : 'N/A'} <br/>
            </Col>
          </Row>
          <Row className="row-eq-height">
            <Col xs={4}><b>Home Loan</b></Col>
            <Col xs={8}>
              Amount: RM {obj.ccris ? obj.ccris.homeLoanAmount : 'N/A'} <br/>
            Count: RM {obj.ccris ? obj.ccris.homeLoanCount : 'N/A'} <br/>
            </Col>
          </Row>
          <Row className="row-eq-height">
            <Col xs={4}><b>Overdraft Loan</b></Col>
            <Col xs={8}>
              Amount: RM {obj.ccris ? obj.ccris.overdraftLoanAmount : 'N/A'} <br/>
            Count: RM {obj.ccris ? obj.ccris.overdraftLoanCount : 'N/A'} <br/>
            </Col>
          </Row>
          <Row className="row-eq-height">
            <Col xs={4}><b>Personal Loan</b></Col>
            <Col xs={8}>
              Amount: RM {obj.ccris ? obj.ccris.personalLoanAmount : 'N/A'} <br/>
            Count: RM {obj.ccris ? obj.ccris.personalLoanCount : 'N/A'} <br/>
            </Col>
          </Row>
          <Row className="row-eq-height">
            <Col xs={4}><b>Total Commitment</b></Col>
            <Col xs={8}> RM {obj.ccris ? obj.ccris.totalCommitmentCents : 'N/A'} </Col>
          </Row>
        </Col>
      </Row>
    );

    if (successData.length > 0 ) {
      return successData;
    }
    return <Row className="defaultRow"><h3>No Record</h3></Row>;
  }

  render() {
    const { loading } = this.props;
    return (
      <div className="ChecksPrint">
        <Table>
          <Table.Header>
            <Col xs={1}>Created At</Col>
            <Col xs={2}>User Details</Col>
            <Col xs={2}>User Contacts</Col>
            <Col xs={3}>Results</Col>
            <Col xs={4}>CCRIS</Col>
          </Table.Header>
          <Table.Body>
              {
                loading ?
                <Row className="defaultRow">
                  <Logo medium spin />
                </Row>
                : this.filterSuccess()
              }
          </Table.Body>
        </Table>
      </div>
    )
  }
}

export default connect(ChecksPrint.mapStateToProps)(ChecksPrint);



// WEBPACK FOOTER //
// ./src/containers/ChecksPrint.jsx